import React, { Component } from "react";
import Slider from "react-slick";
import requireAuth from "components/hoc/requireAuth";
import AnnouncementsList from "components/widgets/announcements/AnnouncementsList";
import Videos from "components/widgets/introVideos/Videos";
import TrainingsList from "components/widgets/training/TrainingsList";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import MobileBreakpoint from "util/responsive/phone_breakpoint";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TotalEmployee from "components/widgets/stats/TotalEmployee";
import TrainingCompleteness from "components/widgets/stats/TrainingCompleteness";
import EmployeeTurnover from "components/widgets/stats/EmployeeTurnover";
import ELearningCompleteness from "components/widgets/stats/ELearningCompleteness";

class ManagerHome extends Component {
  settings = {
    className: "topGraphicArea slick-dotted",
    dots: true,
    draggable: true,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  render() {
    // if (this.props.auth.tokenExpired) {
    //   console.log("null");
    //   return null;
    // }
    return (
      <>
        <section className="infoArea">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 dashboardWidgetArea">
                <DesktopBreakpoint>
                  <div className="row d-none d-sm-none d-md-flex d-lg-flex">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 dashboardItemArea">
                      {/* <TotalEmployee /> */}
                      <TrainingCompleteness />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 dashboardItemArea">
                      <ELearningCompleteness />
                    </div>
                  </div>
                </DesktopBreakpoint>
                <TabletBreakpoint>
                  <div className="row d-none d-sm-none d-md-flex d-lg-flex">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 dashboardItemArea">
                      {/* <TotalEmployee /> */}
                      <TrainingCompleteness />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-4 dashboardItemArea">
                      <ELearningCompleteness />
                    </div>
                  </div>
                </TabletBreakpoint>
                <MobileBreakpoint>
                  <Slider {...this.settings}>
                    {/* <TotalEmployee /> */}
                    <TrainingCompleteness />
                    <ELearningCompleteness />
                  </Slider>
                </MobileBreakpoint>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 mt-4 dashboardWidgetArea">
                <AnnouncementsList showAllEnabled="true" />
              </div>
            </div>
          </div>
        </section>
        <section className="tableArea mt-4">
          <div className="container my-3" style={{ position: "relative" }}>
            <TrainingsList />
          </div>
        </section>
        <section className="VideoArea mt-4">
          <div className="container" style={{ position: "relative" }}>
            <div className="row">
              <Videos showAllEnabled="true" />
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default requireAuth(ManagerHome);
